if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      // On mobile, always keep footer blocks open
      if (FoxTheme.config.mqlMobile) {
        this.open = true;
        return;
      }

      // On tablet/desktop, respect the openDefault setting
      if (FoxTheme.config.mqlTablet) {
        if (!this.openDefault) this.open = false;
      }

      document.addEventListener('matchMobile', () => {
        // On mobile, always keep open
        this.open = true;
      });

      document.addEventListener('matchTablet', () => {
        // On tablet, respect openDefault
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchTablet', () => {
        // When going back to desktop, always open
        this.open = true;
      });

      document.addEventListener('unmatchMobile', () => {
        // When leaving mobile, respect openDefault
        if (!this.openDefault && FoxTheme.config.mqlTablet) {
          this.open = false;
        } else {
          this.open = true;
        }
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}